export default __webpack_public_path__ + "static/media/project_thumbnail_jumplabs.5c5739e7.png";